import * as Yup from 'yup';
import { isValidSAIDNumber, ProgrammeAttendanceReasonDto } from '@ecdlink/core';

export interface ChildExtraInformationFormModel {
  race?: string;
  genderId?: string;
  childFirstname: string;
  homeLanguages?: string[];
  otherLanguages?: string;
  childIdField?: string;
  dobDay?: number;
  dobMonth?: number;
  dobYear?: number;
  dob?: Date;
  dobValid?: boolean;
  reason?: ProgrammeAttendanceReasonDto;
  otherReason?: string;
}

export const childExtraInformationFormSchema = Yup.object().shape({
  race: Yup.string().required(),
  genderId: Yup.string().required(),
  homeLanguages: Yup.array().required().min(1),
  dobValid: Yup.bool().isTrue().required(),
  childIdField: Yup.string()
    .nullable()
    .transform((val) => (val?.trim() === '' ? null : val))
    .test(
      'id-length-or-empty',
      'ID number must be 13 digits or left blank',
      (value) => !value || value.length === 13
    )
    .test(
      'is-valid-said',
      'Please enter a valid ID number',
      (value) => !value || isValidSAIDNumber(value)
    ),
});
